import React, { useEffect,useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { Row, Col, Form, Select } from "antd";
import Card from '../../components/Card';
import TEXT from '../../components/Text';
import { TextInput, PhoneInput } from '../../components/FormFields';
import { ButtonPrimary, ButtonSecondary } from '../../components/Button';
import Switcher from '../../components/Switcher';
import { getRolesList } from "../../../redux/actions/adminPanel/adminSettings";
import { getAdminUserById, updateAdminUser, resetAdminUserState } from '../../../redux/actions/adminPanel/adminUsers';
import {scrollContainerIntoView} from '../../helpers/scrollIntoView';
import './style.scss';
import { sanitizeInputValidator } from '../../../utils/sanitizeInput';
import { identity } from "../../../utils/getIdentity";
import { useTranslation } from "react-i18next";

const UserEdit = ({
  userData,
  userDateFetching,
  getAdminUserById,
  updateAdminUser,
  resetAdminUserState,
  rolesList,
  getRolesList
}) => {
  const { userId } = useParams();
  const [form] = Form.useForm();
  const userEditRef = useRef();
  const [currentRole, setCurrentRole] = useState('');
  const { t } = useTranslation();

  useEffect(() => () => resetAdminUserState(), []);

  useEffect(() => {
    if (userId) {
      getAdminUserById(userId);
      getRolesList();
    }
  }, [userId]);

  useEffect(() => {
    if (Object.keys(userData).length) {
      form.resetFields();
    }
  }, [userData]);

  useEffect(() => {
    if (userData && userData?.accessRole?.id) {
      setCurrentRole(userData?.accessRole?.id)
    }
  }, [userData]);

  const handleSubmit = (id, values) => {
    updateAdminUser(id, { ...values, phone: values?.phone ? '+' + values.phone.replace(/^\++/, '') : undefined, accessRole: userData?.roles?.includes('admin') ? currentRole : undefined });
    setTimeout(() => {
      getAdminUserById(id);
    }, 500)
  }

  useEffect(() => {
    scrollContainerIntoView(userEditRef);
  }, []);

  return (
    <div className="user-edit" ref={userEditRef}>
      <Card>
        <TEXT.pageTitle>{t('admin.edit')}</TEXT.pageTitle>
        <Form
          form={form}
          name="user-edit-form"
          initialValues={{
            name: userData.name,
            surname: userData.surname,
            email: userData.email,
            phone: userData.phone,
            isActive: userData.isActive,
            accessRole: currentRole
          }}
          onFinish={values => handleSubmit(userId, values)}
        >
          <div className="user-edit__section">
            <TEXT.sectionTitle>{t('admin.personal_info')}</TEXT.sectionTitle>
            <Row gutter="30" className={`user-edit__inputs-wrap user-edit__inputs-wrap-${identity}`}>
              <Col>
                <TextInput name="name" maxLength={true} label={t('admin.first_name')} placeholder={t('admin.first_name')} rules={[sanitizeInputValidator]} />
              </Col>
              <Col>
                <TextInput name="surname" maxLength={true} label={t('admin.last_name')} placeholder={t('admin.last_name')} rules={[sanitizeInputValidator]} />
              </Col>
            </Row>
          </div>
          <div className="user-edit__section">
            <TEXT.sectionTitle>{t('admin.email_and_phone')}</TEXT.sectionTitle>
            <TEXT.sectionDescription className={`system-fee-switcher__description system-fee-switcher__description-${identity}`}>
              {t('admin.your_verified_email')}
            </TEXT.sectionDescription>
            <Row gutter="30" className={`user-edit__inputs-wrap user-edit__inputs-wrap-${identity}`}>
              <Col>
                <TextInput name="email" maxLength={false} label={t('admin.email')} placeholder={t('admin.email')} />
              </Col>
              <Col>
                <PhoneInput name="phone" label={t('admin.phone')} />
              </Col>
            </Row>
          </div>
          <Switcher name="isActive" title={t('admin.active_user')} />
        </Form>
      </Card>
      <div className="user-edit-buttons">
        <Link to="/admin/users">
          <ButtonSecondary>{t('admin.back')}</ButtonSecondary>
        </Link>
        <ButtonPrimary type="submit" onClick={form.submit} disabled={userDateFetching} loading={userDateFetching}>
          {t('admin.save')}
        </ButtonPrimary>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  userData: state.adminUsers.editableUser.data,
  userDateFetching: state.adminUsers.editableUser.fetching,
  rolesList: state.adminSettings.rolesList,
});

const mapDispatchToProps = {
  getAdminUserById,
  updateAdminUser,
  resetAdminUserState,
  getRolesList
};

export default connect(mapStateToProps, mapDispatchToProps)(UserEdit);
